import _ from "lodash";
import { flowTypes, pageConfig } from '@/common/service/page-config';
import { planTypes } from '@/common/constants';
import { isZoomPhone } from '@/common/service/computers/plans/pbx';

export const boughtPlanFilter = (getters) => {
  const boughtPlans = getters.boughtPlans || [];
  const { type, oldPlanCode, editConfig = {} } = pageConfig;
  const planType = editConfig?.planType;

  switch (type) {
    case flowTypes.edit: {
      if (isZoomPhone(planType) || planType === planTypes.TOLLFREE) {
        return boughtPlans.filter(item => item.type !== planType);
      } else {
        // filter current plan
        return boughtPlans.filter(item => item.plan_code !== oldPlanCode);
      }
    }
    case flowTypes.pro2biz:
      // If meeting upgrade to others, remove old meeting plan.
      return boughtPlans.filter(item => item.type !== planTypes.ZOOM_MEETING);
    case flowTypes.trial2paid:
      // FREE TRIAL - isTrialPlan: new free trial with paid plan code, isFreeTrial: old free trial with separate trial code
      return boughtPlans.filter((item) => !item.isFreeTrial && !item.isTrialPlan);
    case flowTypes.mixBuy:
      // MIX_BUY
      // filter have purchased plans with mix buy flow
      const editPlanTypes = getters.mixBuyPlanType4FlowType?.[flowTypes.edit];
      return boughtPlans.filter(item => !_.includes(editPlanTypes, item?.type));
    default:
      return boughtPlans;
  }
};
